<div class="row">
  <div class="col-12 mb-2">
    <h4 class=" mb-0 font-header-1">Agency</h4>
  </div>
  <div class="col-12">
    <div class="card mt-2 pt-1">
      <div class="row">
      </div>
      <div class="card-body">
        <div class="row a-body d-flex align-items-center">
          <div class="col-lg-4 col-md-4 col-sm-12 ag1 mt-3">
            <button type="button" class="btn btn-sm" (click)="AgencyCreateupdate('new')" *ngIf="fp.agencycreate">
              Add Agency
            </button>
            <button type="button" class="btn  btn-sm ms-3" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000' ||
          global.globalAgencyId == null || global.globalAgencyId == undefined " (click)="getHHAXAggregator()">
              Aggregator Credentails</button>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 ag2 ">
            <label>Agency Name</label>
            <div class="d-flex">

              <input type="text" (keyup.enter)="filterchange()" id="inputGroupSelect02"
                class="form-control element_width1" [(ngModel)]="SearchText" />
              <i class="bi bi-search mt-1 sr-ico " for="inputGroupSelect02" (click)="getAgencyList()"></i>
            </div>
          </div>
          <div class="col-lg-2 ag3">
            <span class="row">
              <span class="col-12"><label>Show agency&nbsp;</label></span>
              <span class="col-12"><ng-select class="w-70" [(ngModel)]="ListSendBO.statusLid" (change)="getAgencyList()"
                  style="color: black;width:65%" [clearable]="false" [searchable]="true" [items]="agencyStatusList"
                  bindLabel="lovName" bindValue="id">
                </ng-select></span>
            </span>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 ag4 mt-3">
            <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
              <i class="fa fa-repeat"> </i>Refresh
            </button>
          </div>
        </div>

        <div class="row mt-3 pt-3">
          <div class="col mt-2">
            <ejs-grid #grid [dataSource]="data | async" [allowPaging]="true" [pageSettings]="initialPage"
              [filterSettings]="filterSettings" [allowFiltering]="true" [allowResizing]="true"
              (dataStateChange)="dataStateChange($event)" [showColumnChooser]="true"
              (actionBegin)="onActionComplete($event); actionBegin($event)" [allowSorting]="true">
              <e-columns>
                <e-column headerText="Action" uid="action" textAlign="center" minWidth="100"
                  [showInColumnChooser]="false">
                  <ng-template #template let-data>
                    <button class="btn btn-edit-table text-center" data-bs-toggle="modal" data-bs-target="#agencymodal"
                      *ngIf="fp.agencyupdate" (click)="
                AgencyCreateupdate('edit'); selectAgencydetails(data)
              ">
                      <i class="fa fa-edit"></i></button>&nbsp;
                  </ng-template>
                </e-column>
                <e-column field="agencyName" minWidth="140" headerText="Name" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="agencyCode" minWidth="100" headerText="Code" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="email" minWidth="100" headerText="Email" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="phone" minWidth="100" headerText="Phone" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="street" minWidth="100" headerText="Street" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="city" minWidth="100" headerText="City" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="state" minWidth="100" headerText="State" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="zipCode" minWidth="100" headerText="Zip Code" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="statusLidName" headerText="Status" minWidth="100" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>

                <!--------------------------------table header icon---------------->
                <e-column width="50" [showInColumnChooser]="false">
                  <ng-template #headerTemplate let-data>
                    <div>
                      <span id="show" (click)="show()"><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- /////////////////////////// Agency Create and Update //////////////////////////////////// -->
<span id="openModal" data-bs-target="#agencymodal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="agencymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span *ngIf="ModelType == 'new'"> Create Agency</span>
          <span *ngIf="ModelType == 'edit'">Update Agency</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr != ''" role="alert">
        <p>{{ saveErr }}</p>
        <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr = ''">
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-2 d-flex justify-content-between">
                <label class="font-header mt-1">General Info</label>

                <button class="btn btn-sm text_right" [disabled]="ModelType == 'new'" data-bs-toggle="modal"
                  data-bs-target="#CompanyModal" (click)="companyConfig(Agency)">
                  Company
                </button>
              </div>
              <hr />
              <form [formGroup]="AgencyGroup">
                <div class="row">
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input type="file" id="imageUpload" accept=".png, .jpg, .jpeg" />
                        <label for="imageUpload"></label>
                      </div>
                      <div class="avatar-preview">
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-2 col-md-2 col-xs-3">
                    <label class="label">Status&nbsp;<sup class="super-script">&nbsp;*</sup></label>
                  </div>
                  <div class="col-lg-2 col-sm-3 col-md-3 col-xs-3">
                    <select class="form-control" [(ngModel)]="Agency.statusLid" formControlName="statusLid">
                      <option *ngFor="let st of statusList" [value]="st.Key">
                        {{ st.Value }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="
                      AgencyGroup.controls.statusLid.touched &&
                      AgencyGroup.controls.statusLid.invalid
                    ">
                    <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.statusLid.errors.required">
                      Agency status is required
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12 lablestyle">
                    <label class="label">Name&nbsp;<sup class="super-script">*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyName"
                      formControlName="agencyName" />

                    <div *ngIf="
                        AgencyGroup.controls.agencyName.touched &&
                        AgencyGroup.controls.agencyName.invalid
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.agencyName.errors.required">
                        Agency name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Code&nbsp;<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyCode"
                      (ngModelChange)="
                        checkpopup('Code');
                        checkfirstLetter($event, AgencyGroup.value.agencyCode)
                      " (keypress)="omit_special_char($event)" (keydown.space)="$event.preventDefault()"
                      formControlName="agencyCode" [attr.disabled]="ModelType != 'new' ? 'disabled' : null"
                      minlength="4" />
                  </div>

                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Short Name<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.agencyShortName"
                      formControlName="agencyShortName" />
                    <div *ngIf="
                        AgencyGroup.controls.agencyShortName.touched &&
                        AgencyGroup.controls.agencyShortName.invalid
                      ">
                      <div style="color: red; text-align: left" *ngIf="
                          AgencyGroup.controls.agencyShortName.errors.required
                        ">
                        Short name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="
                    AgencyGroup.controls.agencyCode.invalid &&
                    AgencyGroup.controls.agencyCode.touched
                  ">
                  <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.agencyCode.invalid">
                    Agency code should be more than three character
                  </div>
                </div>
                <div style="color: red; text-align: left" *ngIf="alphaErr">
                  Agency code should be starts with alphabets
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Email<sup class="super-script">&nbsp;*</sup></label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.email"
                      formControlName="email" />
                    <div *ngIf="
                        AgencyGroup.controls.email.invalid &&
                        AgencyGroup.controls.email.touched
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.email.errors">
                        Enter valid email
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Phone</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.phone" minlength="14"
                      maxlength="14" formControlName="phone" [(ngModel)]="Agency.phone" (ngModelChange)="
                        DemographicPhoneFormat('phone'); checkpopup('Phone')
                      " (keypress)="keyPress($event)" />
                    <div *ngIf="
                        AgencyGroup.controls.phone.invalid &&
                        (AgencyGroup.controls.phone.dirty ||
                          AgencyGroup.controls.phone.touched)
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.phone.errors">
                        Enter valid 10 digit number
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Street</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.street"
                      formControlName="street" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Fax</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.fax" minlength="14"
                      [(ngModel)]="Agency.fax" maxlength="14" formControlName="fax" (ngModelChange)="
                        DemographicPhoneFormat('fax'); checkpopup('fax')
                      " (keypress)="keyPress($event)" />

                    <div *ngIf="
                        AgencyGroup.controls.fax.invalid &&
                        (AgencyGroup.controls.fax.dirty ||
                          AgencyGroup.controls.fax.touched)
                      ">
                      <div style="color: red; text-align: left" *ngIf="AgencyGroup.controls.fax.errors">
                        Enter valid 10 digit number
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">City</label>
                    <input type="text" class="form-control text_right width66 mt-1" [(ngModel)]="Agency.city"
                      formControlName="city" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">State</label>
                    <ng-select class="text_right width66 mt-1" [items]="stateList" [searchable]="true"
                      [(ngModel)]="Agency.state" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                      formControlName="state"></ng-select>
                  </div>
                </div>
                <div class="row mb-4 mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">ZipCode</label>
                    <input type="text" class="form-control text_right width66" [(ngModel)]="Agency.zipCode"
                      formControlName="zipCode" minlength="5" maxlength="10" (keypress)="keyPress($event)" />
                  </div>
                </div>
                <label class="font-header fs-5 col-12 border-2">Alternate Address</label>
                <hr />
                <div class="row mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">Street</label>
                    <input type=" text" class="form-control width66 text_right" formControlName="altStreet"
                      [(ngModel)]="Agency.altStreet" />
                  </div>
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">City</label>
                    <input type="text" class="form-control text_right width66 mt-1" formControlName="altCity"
                      [(ngModel)]="Agency.altCity" />
                  </div>
                </div>

                <div class="row mb-1 mt-2">
                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">State</label>
                    <ng-select class="text_right width66 mt-1" [items]="stateList" [searchable]="true"
                      [(ngModel)]="Agency.altState" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                      formControlName="altState">
                    </ng-select>
                  </div>

                  <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
                    <label class="label">ZipCode</label>
                    <input type="text" class="form-control text_right width66" formControlName="altZipcode"
                      [(ngModel)]="Agency.altZipcode" minlength="5" maxlength="10" (keypress)="keyPress($event)" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" [disabled]="AgencyGroup.invalid || alphaErr || IsButtonDisable" (click)="SaveOrUpdateAgency()">
          <span *ngIf="ModelType == 'new'"> Save</span>
          <span *ngIf="ModelType == 'edit'">Update & Close</span>
        </button>
        <button type="button" class="btn btn-sm" (click)="openDialog()" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#closemodal"></span>
<div class="modal fade modalbackgrod" id="closemodal">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Close Alert</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal">
        
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>You want to close without save?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeFun()">
          Yes
        </button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------- Company modal ----------------------------------------------->
<span id="companySpan" data-bs-toggle="modal" data-bs-target="#CompanyModal">
</span>
<div class="modal fade modalbackgrod" id="CompanyModal" tabindex="-1" data-bs-backdrop="static"
  style="background-color: rgba(0, 0, 0, 0.5)" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <!-- ================== Company TABLE VIEW ================ -->
        <!-- ================== Company EDIT/ADD VIEW ================ -->
        <app-company-list *ngIf="toCompanylist.isView" (listOutputEmit)="agencyToEdit($event)"
          [listInput]="toCompanylist">
        </app-company-list>

      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<!-- Aggregator-->
<span id="openAggregator" data-bs-toggle="modal" data-bs-target="#AggregatorModal"></span>
<div class="modal hide fade modalbackgrod" id="AggregatorModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Aggregator Credentails</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <button class="btn blue-btn mt-2 " data-bs-toggle="modal" data-bs-target="#CreateorUpdateAggregatorModal"
              (click)="GetCompanyDropdown()">
              Add Aggregator</button>&nbsp;&nbsp;
          </div>
        </div>
        <!-- ejs-grid -->
        <div class="row">
          <div class="col-lg-12">
            <ejs-grid #gridHHAX  [dataSource]="AsDataGridList | async" [allowResizing]='true' [allowSorting]='true' [allowPaging]='true'
              [allowFiltering]='true' [pageSettings]='initialPage' [filterSettings]='filterSettings'
              [showColumnChooser]='true'>
              <e-columns>
                <e-column headerText="Actions" uid="action" textAlign="center" [allowFiltering]="false"
                  [showInColumnChooser]='false' minWidth=100>
                  <ng-template #template let-data>
                    <button class="btn btn-edit-table" (click)="getDetails(data)" data-bs-toggle="modal"
                      data-bs-target="#CreateorUpdateAggregatorModal"><i class="fa fa-edit"></i></button>&nbsp;
                  </ng-template>
                </e-column>
                <e-column field="companyName" headerText="Company Name" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="client_id" headerText="Client" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="client_secret" headerText="Client Secret" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="providerTaxId" headerText="Provider Tax" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="identifier" headerText="Identifier" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="qualifier" headerText="Qualifier" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div>
                      <span id='show' (click)='showAggregator()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                        </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </div>
        </div>
        <!-- for Create Aggregator -->
        <span id="openCreateorUpdateAggregator" data-bs-toggle="modal"
          data-bs-target="#CreateorUpdateAggregatorModal"></span>
        <div class="modal hide fade modalbackgrod" id="CreateorUpdateAggregatorModal" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title font-header" *ngIf="saveHHAXInfo.id=='00000000-0000-0000-0000-000000000000'"
                  id="exampleModalLabel">Create
                  Aggregator</h5>
                <h5 class="modal-title font-header" *ngIf="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                  id="exampleModalLabel">Update
                  Aggregator</h5>
                <button type="button" class="btn-close" (click)="clearField()"></button>
              </div>
              <div class="modal-body">
                <!-- Client -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Client<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string"
                      [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                      [(ngModel)]="saveHHAXInfo.client_id" />
                  </div>
                </div>
                <!-- Company -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Company<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <ng-select [clearable]="true" [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                      [items]="companyList" bindLabel="Value" bindValue="Key" [(ngModel)]="saveHHAXInfo.companyId">
                    </ng-select>
                  </div>
                </div>
                <!-- ProviderTaxId -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">ProviderTax<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string"
                      [disabled]="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'"
                      [(ngModel)]="saveHHAXInfo.providerTaxId" />
                  </div>
                </div>
                <!-- Client Secret -->
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Client Secret<sup class="super-script">*</sup></label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string" [(ngModel)]="saveHHAXInfo.client_secret" />
                  </div>
                </div>
                <div class="row" *ngIf="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Identifier</label>
                  </div>
                  <div class="col-lg-12">
                    <input class="form-control" type="string" [(ngModel)]="saveHHAXInfo.identifier" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight:bold">Qualifier</label>
                  </div>
                  <div class="col-lg-12">
                    <ng-select [(ngModel)]="saveHHAXInfo.qualifier"  [items]="QualifierList" bindLabel="Value" bindValue="Key" (change)="saveHHAXInfo.identifier=null"></ng-select>
                    
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="SaveorUpdateHHAXAggregator()" [disabled]="IsButtonDisable || saveHHAXInfo.client_id=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.client_id==undefined ||
                saveHHAXInfo.client_id==''||
                saveHHAXInfo.companyId=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.companyId==undefined ||
                saveHHAXInfo.providerTaxId=='00000000-0000-0000-0000-000000000000' ||saveHHAXInfo.providerTaxId==undefined ||
                saveHHAXInfo.providerTaxId=='' ||
                saveHHAXInfo.client_secret=='00000000-0000-0000-0000-000000000000' ||   saveHHAXInfo.client_secret==undefined ||
                saveHHAXInfo.client_secret=='' ">
                  <span *ngIf="saveHHAXInfo.id=='00000000-0000-0000-0000-000000000000'">Save & Close</span>
                  <span *ngIf="saveHHAXInfo.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="clearField()">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>